import axios from 'axios';
import qs from 'qs';
import storageUtils from '../utils/storageUtils';

const CancelToken = axios.CancelToken
let sources = []
let removeSource = (config) => {
    for (let source in sources) {

        if (sources[source].umet === config.url + '&' + config.method) {
            sources[source].cancel("Request canceled")
            sources.splice(source, 1)
        }
    }
}


axios.interceptors.request.use(config => {
    let url = config.url.split('/');
    let method = url[url.length - 1]
    if (method !== 'g_single_translation' && method !== 's_one_third_party_app_trans' && method !== 's_lan_auto_sync_trans') {
        removeSource(config)
        config.cancelToken = new CancelToken((c) => {

            sources.push({ umet: config.url + '&' + config.method, cancel: c })
        })
    }
    return config
}, error => {
    return Promise.reject(error)
})


axios.interceptors.response.use(response => {

    removeSource(response.config)
    return response
}, error => {
    return Promise.reject(error)
})

export default function ajax(url, data = {}, type = 'GET', headers = "false") {
    return new Promise((resolve, reject) => {
        const token = storageUtils.get('NASadminToken') || ''
        const defaultHeaders = {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        if (token) {
            defaultHeaders['Authorization'] = `Bearer ${token}`
        }
        let finalHeaders = defaultHeaders
        if (headers && typeof headers === 'object') {
            finalHeaders = { ...defaultHeaders, ...headers }
        } else if (headers === 'json') {

            finalHeaders['Content-Type'] = 'application/json'
        }
        let request


        if (type.toUpperCase() === 'GET') {
            request = axios.get(url, {
                params: data,
                headers: finalHeaders
            })
        }

        else if (type.toUpperCase() === 'POST') {
            if (headers === 'json') {
                request = axios.post(url, data, { headers: finalHeaders })
            } else {

                request = axios.post(url, qs.stringify(data), { headers: finalHeaders })
            }
        }


        request
            .then(response => {
                if(response.data.status === 404) window.location.href = '/login'
                resolve(response.data)
            })
            .catch(error => {

                if (error.response?.status === 401) {

                    localStorage.removeItem('NASadminToken')
                    window.location.href = '/login'
                }
                reject(error)
            })
    })
}
